<template>
  <app-base-sheet ref="sheet">
    <template v-slot:title> Магазин </template>
    <template v-slot:content>
      <app-base-sheet-menu-item
        v-for="category in enrichedCategories"
        :key="category.id"
        :title="category.name"
        :image="category.image"
        @click="navigateTo(category.id)"
      />
    </template>
  </app-base-sheet>
</template>

<script>
import { ref, onMounted, onUnmounted, computed } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import AppBaseSheet from "@/components/common/ui/AppBaseSheet.vue";
import AppBaseSheetMenuItem from "@/components/common/ui/AppBaseSheetMenuItem.vue";
import { eventBus, events } from "@/eventBus";

import menuImage0 from "@/assets/shop/img-uncategorized.jpg";
import menuImage1 from "@/assets/shop/img-router.png";
import menuImage2 from "@/assets/shop/img-tv-box.png";
import menuImage3 from "@/assets/shop/img-other.jpg";
import menuImage4 from "@/assets/shop/img-power-bank.png";

export default {
  name: "ShopSheetComponent",
  components: {
    AppBaseSheet,
    AppBaseSheetMenuItem,
  },
  setup() {
    const sheet = ref(null);
    const router = useRouter();
    const store = useStore();

    const categoryImagesById = {
      0: menuImage0,
      1: menuImage1,
      2: menuImage2,
      3: menuImage3,
      4: menuImage4,
    };

    const enrichedCategories = computed(() =>
      store.getters["shop/availableCategories"].map((cat) => ({
        ...cat,
        image: categoryImagesById[cat.id] || null,
      }))
    );

    const navigateTo = (id) => {
      sheet.value?.close();
      router.push({ name: "shop", query: { categories: String(id) } });
    };

    onMounted(() => {
      eventBus.$on(events.OPEN_SHEET_SHOP, () => {
        sheet.value?.open();
      });
    });

    onUnmounted(() => {
      eventBus.$off(events.OPEN_SHEET_SHOP);
    });

    return {
      sheet,
      enrichedCategories,
      navigateTo,
    };
  },
};
</script>
